// src/components/ProtectedRoute.tsx

import { AuthContext } from '@/contexts/authContext';
import { Spinner } from '@/components/Spinner';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom'
import { ReactNode } from 'react';

interface ProtectedRouteProps {
    children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { user, isLoading } = useContext(AuthContext);

    if (isLoading) {
        return <Spinner />;
    }
    return user ? <>{children}</> : <Navigate to="/login" />;
};


export default ProtectedRoute;
